import * as ACTION_TYPES from './Types';

const initialState = {
  sizes: {},
  message: '',
  error: null,
}

export const sizeReducer = (state = initialState, action) => {
  switch (action.type) {



    case ACTION_TYPES.GETSIZE_SUCCESS:
      return {
        ...state,
        sizes: action.payload.data,
        message: action.payload.message,
      }

    case ACTION_TYPES.GETSIZE_ERROR:
      return {
        ...state,
        message: action.payload.message,
      }
    case ACTION_TYPES.ADDSIZE_SUCCESS:
    case ACTION_TYPES.UPDATESIZE_SUCCESS:
    case ACTION_TYPES.CHANGEACTION_SUCCESS:
      return {
        ...state,
        categories: action.payload.data,
        message: action.payload.message,
      }

    case ACTION_TYPES.ADDSIZE_ERROR:
    case ACTION_TYPES.UPDATESIZE_ERROR:
    case ACTION_TYPES.CHANGEACTION_ERROR:
      return {
        ...state,
        message: action.payload.message,
      }

    default:
      return state;
  }
}
